const RecoverSVG = (props) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Circular arrow representing restore/recover */}
    <path
      d="M12 5V2L7 7L12 12V9C15.31 9 18 11.69 18 15C18 18.31 15.31 21 12 21C8.69 21 6 18.31 6 15H4C4 19.42 7.58 23 12 23C16.42 23 20 19.42 20 15C20 10.58 16.42 7 12 7V5Z"
      fill={props.fill || "#4CAF50"} // green color by default
    />
  </svg>
);

export default RecoverSVG;
